import { Alert } from "@texada/ui";
import axios from "axios";
import { cloneDeep, isEmpty } from "lodash";
import i18n from "i18n/i18n";
import * as types from "constants/ActionTypes";
import { SERVER_ERROR_500 } from "constants/AppConstants";
import DocumentActions from "helpers/DocumentActions";
import { getApiErrorMsg } from "helpers/helper";
import { get, head } from "lodash"

axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFToken";

export const selectUser = data => (dispatch, getState) => {
  return dispatch({
    type: types.FETCH_USERS,
    value: {
      userSelected: data
    }
  });
};

export const selectWorkOrder = data => (dispatch, getState) => {
  data.isEdit = true;
  return dispatch({
    type: types.FETCH_WORKORDERS,
    value: {
      workOrderSelected: data,
      workOrderUpdated: false
    }
  });
};

export const updateWoInRedux = (updatedWorkOrder, type) => (
  dispatch,
  getState
) => {
  const workOrders = cloneDeep(getState().workOrders);
  const workOrdersMap = cloneDeep(getState().workOrdersMap);
  workOrders.results = updateWorkOrders(
    workOrders.results,
    updatedWorkOrder,
    type
  );
  workOrdersMap.results = updateWorkOrdersMap(
    workOrdersMap.results,
    updatedWorkOrder,
    type
  );
  dispatch({
    type: types.POST_DATA_SUCCESS,
    value: {
      workOrders,
      workOrdersMap,
      workOrderUpdated: true
    }
  });
};

export const sendWODocumentEmail = isLoading => (dispatch, getState) => {
  if (isLoading) return;
  dispatch({
    type: types.PRINT_REQUEST,
    value: {
      isLoading: true
    }
  });
  let { workOrderSelected } = getState();
  const wo_number = workOrderSelected.order_n;
  const emailTo = getState().modal.email;
  const documentActions = new DocumentActions("workorder", wo_number);
  const req_data = {
    signature_b64: null,
    email_to: emailTo
  };

  documentActions
    .sendSignedDocumentEmail(req_data)
    .then(response => {
      if (response.status === 200) {
        dispatch({
          type: types.PRINT_SUCCESS,
          value: {
            modal: {
              isModalOpen: false,
              isEmail: false
            },
            isLoading: false
          }
        });
        Alert.success({
          message: i18n.t("work_worder_emailed", { wo_number })
        });
      }
    })
    .catch(err => {
      if (err.response) {
        if (err.response.status === 500) {
          dispatch({
            type: types.PRINT_ERROR,
            value: {
              modal: {
                isModalOpen: false,
                isEmail: false
              },
              isLoading: false
            }
          });
          Alert.error({
            message: SERVER_ERROR_500
          });
        } else if (err.response.status === 403) {
          dispatch({
            type: types.PRINT_ERROR,
            value: {
              modal: {
                isModalOpen: false,
                isEmail: false
              },
              isLoading: false
            }
          });
          Alert.error({
            message: getApiErrorMsg(err)
          });
        } else {
          dispatch({
            type: types.PRINT_ERROR,
            value: {
              modal: {
                isModalOpen: false,
                isEmail: false
              },
              isLoading: false
            }
          });
          Alert.error({
            message: getApiErrorMsg(err)
          });
        }
      }
    });
};

export const printTag = () => (dispatch, getState) => {
  let { workOrderSelected } = getState();
  let printer_id = getState().modal.printerId;
  let tag =
    workOrderSelected.print_tag_type.trim().length < 1
      ? getState().modal.printTagType
      : workOrderSelected.print_tag_type;
  let operator = workOrderSelected.workordermechanic_set.filter(
    m => m.is_last_mechanic === true
  );
  const mechanic_auth_id = get(operator, "[0].mechanic_auth_id", null)
  const workorder_mechanic_auth_id = get(workOrderSelected, 'workordermechanic_set[0].mechanic_auth_id', null)
  operator =
    mechanic_auth_id
      ? mechanic_auth_id
      : workorder_mechanic_auth_id;
  if (!operator) {
    dispatch({
      type: types.PRINT_TAG_ERROR,
      value: {
        modal: {
          isModalOpen: false,
          isPrint: false
        },
        isLoading: false
      }
    });
    Alert.error({
      message: i18n.t("can_not_print_tag_at_least_one_mechanic_need_to_be_assigned_to_work_order")
    });
    return;
  }
  const printUrl = `/rest-api/print/workorder/${workOrderSelected.id
    }/${printer_id}/${operator}/${getState().auth.user.id}/${tag}`;

  dispatch({
    type: types.PRINT_TAG_REQUEST,
    value: {
      isLoading: true
    }
  });
  if (isEmpty(printer_id.toString())) {
    return dispatch({
      type: types.PRINT_TAG_ERROR,
      value: {
        modal: {
          modalErrorMessage: "No printer selected",
          isModalOpen: true,
          isPrint: false
        },
        isLoading: false
      }
    });
  }
  return axios
    .post(printUrl)
    .then(response => {
      if (response.status === 200) {
        dispatch({
          type: types.PRINT_TAG_SUCCESS,
          value: {
            modal: {
              isModalOpen: false,
              isPrint: false
            },
            isLoading: false
          }
        });
        Alert.success({
          message: i18n.t("print_success")
        });
      }
    })
    .catch(err => {
      if (err.response) {
        if (err.response.status === 500) {
          dispatch({
            type: types.PRINT_TAG_ERROR,
            value: {
              modal: {
                isModalOpen: false,
                isPrint: false
              },
              isLoading: false
            }
          });
          Alert.error({
            message: SERVER_ERROR_500
          });
        } else if (err.response.status === 403) {
          dispatch({
            type: types.PRINT_TAG_ERROR,
            value: {
              modal: {
                isModalOpen: false,
                isPrint: false
              },
              isLoading: false
            }
          });
          Alert.error({
            message: getApiErrorMsg(err)
          });
        } else {
          dispatch({
            type: types.PRINT_TAG_ERROR,
            value: {
              modal: {
                isModalOpen: false,
                isPrint: false
              },
              isLoading: false
            }
          });
          Alert.error({
            message: getApiErrorMsg(err)
          });
        }
      }
    });
  // if(workOrderSelected.print_tag_type.trim().length < 1){
  //   // update the workorder data to state if print success and the print_tag_type get updated
  //   workOrderSelected.print_tag_type = tag
  //   const index = getState().workOrders.results.findIndex(x => x.id === workOrderSelected.id);
  //   const workOrders = getState().workOrders
  //   workOrders.results[index].print_tag_type = tag
  //   dispatch({
  //     type: types.FETCH_WORKORDERS,
  //     value: {
  //       workOrders
  //     }
  //   });
  //   dispatch({
  //     type: types.OPEN_MODAL,
  //     value: {
  //       workOrderSelected
  //     }
  //   });
  // }
};
// ------------------------------------------------------------------------------

export const updateWorkOrders = (workOrders, workOrderSelected, type) => {
  if (workOrders.length === 0) {
    return [];
  }
  let result;
  if (type === "list") {
    result = workOrders.filter(
      workOrder => workOrder.id !== workOrderSelected.id
    );
    result.unshift(workOrderSelected);
  } else if (
    type === "card" &&
    (workOrderSelected.schedule_start ||
      workOrderSelected.workordermechanic_set.length !== 0)
  ) {
    result = workOrders.filter(
      workOrder => workOrder.id !== workOrderSelected.id
    );
  } else {
    result = workOrders;
    const checkInside = result.findIndex(w => w.id === workOrderSelected.id);
    if (checkInside !== -1) {
      result.splice(checkInside, 1, workOrderSelected);
    } else {
      result.unshift(workOrderSelected);
    }
  }
  return result;
};

export const updateWorkOrdersMap = (workOrders, workOrderSelected, type) => {
  if (workOrders.length === 0) {
    return [];
  }
  let result;
  result = workOrders;
  if (type === "map") {
    const checkInside = result.findIndex(w => w.id === workOrderSelected.id);
    if (checkInside !== -1) {
      result.splice(checkInside, 1, workOrderSelected);
    }
  }
  return result;
};
